import React, { useState, useEffect, useRef } from "react";

import ChkBox from "components/Custom/ChkBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import { DEFAULTS } from "common/config";

const dataJson = require("components/Evaluation/ContractForm/gridData.json");

interface defaultProps {
  childRef: any;
  editRows: any[];
}

const Part3 = (props: defaultProps) => {
  const { childRef, editRows } = props;
  const [ehsPolicyCols, setEhsPolicyCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      editable: false,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      editable: false,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: false,
      width: "20%",
    },
    {
      key: "score",
      name: "Score",
      type: "dropdown",
      list: DEFAULTS.SCORES,
      editable: true,
      width: "5%",
    },
  ]);

  let tmpEhsPolicyRows = dataJson["5"]["5.1"];
  let tmpPlanningRows = dataJson["6"]["6.1"];
  for (let key in tmpEhsPolicyRows) {
    tmpEhsPolicyRows[key].checkBoxYes = "";
    tmpEhsPolicyRows[key].checkBoxNo = "";
    tmpEhsPolicyRows[key].score = "";
    tmpEhsPolicyRows[key].comments = "";
  }
  for (let key in tmpPlanningRows) {
    tmpPlanningRows[key].checkBoxYes = "";
    tmpPlanningRows[key].checkBoxNo = "";
    tmpPlanningRows[key].score = "";
    tmpPlanningRows[key].comments = "";
  }

  if (!editRows) {
    tmpEhsPolicyRows = null;
    tmpPlanningRows = null;
  } else if (editRows["records"]) {
    const safetyDetails = JSON.parse(editRows["records"][0]["ehsobjDetails"]);
    for (let i = 0; i < tmpEhsPolicyRows.length; i++) {
      const jsonData = {
        question: tmpEhsPolicyRows[i].question,
        ...safetyDetails[i],
      };
      tmpEhsPolicyRows[i] = jsonData;
    }
    let safetyLen = tmpEhsPolicyRows.length;
    for (let i = 0; i < tmpPlanningRows.length; i++) {
      const jsonData = {
        question: tmpPlanningRows[i].question,
        ...safetyDetails[safetyLen + i],
      };
      tmpPlanningRows[i] = jsonData;
    }
  }

  const [ehsPolicyRows, setEhsPolicyRows] = useState<any[]>(tmpEhsPolicyRows);
  const [planningCols, setPlanningCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      editable: false,
      width: "5%",
      renderCell: ({ planningRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={planningRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...planningRows,
                  check: !planningRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      editable: false,
      width: "5%",
      renderCell: ({ planningRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={planningRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...planningRows,
                  check: !planningRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: false,
      width: "20%",
    },
    {
      key: "score",
      name: "Score",
      type: "dropdown",
      list: DEFAULTS.SCORES,
      editable: true,
      width: "5%",
    },
  ]);
  const [planningRows, setPlanningRows] = useState<any[]>(tmpPlanningRows);

  const grid1Ref: any = useRef();
  const grid2Ref: any = useRef();

  useEffect(() => {
    childRef.saveRecord = saveRecord;
    return () => {
      childRef.saveRecord = null;
    };
  }, []);

  const saveRecord = () => {
    const section1 = grid1Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
        score: s1.score,
      };
    });
    const section2 = grid2Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
        score: s1.score,
      };
    });
    const items = [...section1, ...section2];
    return { items };
  };

  return (
    <>
      <h4 className="ehsHeading1">{dataJson["5"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["5"]["heading2"]}</h5>
      {tmpEhsPolicyRows ? (
        <ExcelGrid
          childRef={grid1Ref}
          cols={ehsPolicyCols}
          rows={tmpEhsPolicyRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}

      <h4 className="ehsHeading1">{dataJson["6"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["6"]["heading2"]}</h5>
      {tmpPlanningRows ? (
        <ExcelGrid
          childRef={grid2Ref}
          cols={planningCols}
          rows={tmpPlanningRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
    </>
  );
};

export default Part3;
